import {
  Box,
  Stack,
  Text,
  Input,
  UnorderedList,
  ListItem,
} from "@chakra-ui/react";
import { InputRowGrid } from "../../shared/InputRowGrid";
import TagsInput from "../../shared/Taginput";

export default function JobTitle() {
  return (
    <>
      <Stack gap={{ base: 5, md: 10 }}>
        <InputRowGrid
          heading={"Title of Job"}
          input={
            <Box>
              <Input
                placeholder="Title of Job"
                size={{ base: "xs", md: "lg" }}
              />
              <Box color="#676767" align="start" pt={5}>
                <Text
                  fontWeight="semibold"
                  fontSize={{ base: "16px", md: "20px" }}
                >
                  Here are some good examples:
                </Text>
                <UnorderedList>
                  <ListItem>
                    Developer needed for creating a responsive WordPress Theme
                  </ListItem>
                  <ListItem>Need a design for a new company logo</ListItem>
                </UnorderedList>
              </Box>
            </Box>
          }
        />
        <InputRowGrid
          heading={"Category"}
          text={
            "Let's categorize your job, which helps us personalize your job details and match your job"
          }
          input={<TagsInput />}
        />
      </Stack>
    </>
  );
}
